// extracted by mini-css-extract-plugin
export var modal = "_mp-0";